export default {
    "profile": "Hồ sơ",
    "logout": "Đăng xuất",
    "dashboard": "bảng điều khiển",
    "password": "Mật khẩu",
    "language": "Ngôn ngữ",
    "paymentbr": "Sự chi trả",
    "subscriptionPaymentMethod": "Phương thức đăng ký và thanh toán",
    "nothingchanged": "Không có gì thay đổi",
    "somethingWentWrong": "Đã xảy ra lỗi! Vui lòng thử lại sau",
    "pleaseTryAgainAfterSometime": "Vui lòng thử lại sau một thời gian",
    "noChanges": "Đã không thay đổi",
    "invalidEmailFormat": "Định dạng email không hợp lệ",
    "chooseYourPreferredLanguage": "Vui lòng chọn ngôn ngữ ưa thích của bạn.",
    "selectLanguage": "Chọn ngôn ngữ",
    "update": "Cập nhật",
    "languagePreferences": "Tùy chọn ngôn ngữ",
    "packageOf": "Gói",
    "satelliteReport": "báo cáo vệ tinh",
    "pastureReport": "báo cáo đồng cỏ",
    "upTo": "Lên đến",
    "animals": "động vật",
    "back": "Mặt sau",
    "perMonth": "Mỗi tháng",
    "perYear": "Mỗi năm",
    "continue": "Tiếp tục",
    "changePlan": "Thay đổi kế hoạch",
    "addOn": "Thêm vào",
    "totalPrice": "Tổng giá",
    "availableAddOns": "Tiện ích bổ sung có sẵn",
    "next": "Kế tiếp",
    "congratulations": "Chúc mừng",
    "done": "XONG",
    "deforestationComplianceAssessment": "Đánh giá tuân thủ phá rừng",
    "warning": "Cảnh báo",
    "yourDataMightLost": "Dữ liệu của bạn có thể bị mất.",
    "clickOnSaveBtnMsg": "Bấm vào nút lưu để bảo vệ dữ liệu của bạn",
    "discardChanges": "Loại bỏ những thay đổi",
    "action": "hành động",
    "sendRequest": "Gửi yêu cầu",
    "success": "Thành công",
    "yourRequestSuccessfullySubmitted": "Yêu cầu của bạn đã được gửi thành công.",
    "informShortly": "Yêu cầu của bạn đã được gửi thành công. Báo cáo phân tích của bạn sẽ sớm được gửi cho bạn.",
    "search": "Tìm kiếm",
    "pending": "Chưa giải quyết",
    "approved": "Tán thành",
    "rejected": "Bị từ chối",
    "primaryGeofence": "Hàng rào địa chất chính",
    "Zero/Negligible Deforestation Probability": "Khả năng Phá rừng Bằng không/Đáng kể",
    "Low Deforestation Probability": "Khả năng Phá rừng Thấp",
    "High Deforestation Probability": "Khả năng Phá rừng Cao",
    "login": {
        "welcome": "Chào mừng! Đăng nhập",
        "welInfo": "Nhập thông tin xác thực của bạn.",
        "login": "Đăng nhập",
        "emailMobile": "Email/Điện thoại di động",
        "forgotPassword": "Quên mật khẩu",
        "register": "Đăng ký",
        "unableToLogin": "Không thể đăng nhập",
        "emailMobileCannotEmpty": "Email/Điện thoại di động không được để trống.",
        "invalidEmailMobileFormat": "Định dạng email/điện thoại di động không hợp lệ.",
        "passwordCannotEmpty": "Mật khẩu không được để trống.",
        "passwordLengthCanlessthan8": "Độ dài mật khẩu không thể ít hơn 8 ký tự.",
        "email": "E-mail",
        "phone": "Điện thoại",
        "or": "HOẶC",
        "alreadyHaveAccount": "Bạn co săn san để tạo một tai khoản",
        "loginNow": "Đăng nhập ngay bây giờ",
        "registerOption": "Chọn một tùy chọn để đăng ký",
        "signUpWith": "Đăng ký với"
    },
    "user": {
        "profileUpdated": "Hồ sơ đã được cập nhật thành công",
        "profileNotUpdated": "Hồ sơ chưa được cập nhật",
        "otpSentOnEmail": "OTP đã được gửi thành công!",
        "otpSentSuccessFully": "Mã OTP của bạn đã được gửi",
        "unableToVerifyEmail": "Không thể xác minh email",
        "emailCanNotBeEmpty": "Trường email không được để trống",
        "firstName": "Tên đầu tiên",
        "lastName": "Họ",
        "email": "E-mail",
        "mobile": "Điện thoại di động",
        "currentPassword": "Mật khẩu hiện tại",
        "newPassword": "mật khẩu mới",
        "repeatNewPassword": "Lặp lại mật khẩu mới",
        "firstNameRequired": "Tên là bắt buộc.",
        "lastNameRequired": "Họ là bắt buộc",
        "emailRequired": "Email thì cần thiết",
        "onlyAlphabet": "Chỉ có thể chứa bảng chữ cái",
        "notMoreThan15Char": "Không thể nhiều hơn 15 ký tự",
        "phoneCannotLessThan8Char": "Điện thoại không thể ít hơn 8 ký tự",
        "countryCodeRequire": "Mã quốc gia là bắt buộc",
        "changePassword": "Đổi mật khẩu",
        "goodIdeaToUsePassword": "Bạn nên sử dụng mật khẩu mạnh mà bạn không sử dụng ở nơi khác.",
        "enterCurrentPassword": "Nhập mật khẩu hiện tại",
        "enterNewPassword": "Nhập mật khẩu mới",
        "reEnterPassword": "Nhập lại mật khẩu",
        "pleaseTypeOldPassword": "Vui lòng gõ mật khẩu cũ.",
        "pleaseTypeNewPassword": "Vui lòng nhập mật khẩu mới.",
        "pleaseTypeConfirmPassword": "Vui lòng gõ xác nhận mật khẩu.",
        "passwordChangedSuccesFully": "Đã thay đổi mật khẩu thành công",
        "passwordDoesNotMatch": "Mật khẩu không đúng.",
        "passwordRequired": "Cần có mật khẩu",
        "emailOrPhoneIsRequired": "Email hoặc số điện thoại là bắt buộc"
    },
    "subscription": {
        "subscription": "Đăng ký",
        "membershipPlan": "Gói thành viên",
        "currentMembershipPlan": "Kế hoạch thành viên hiện tại",
        "validUpTo": "Hợp lệ lên đến",
        "viewAllAddOns": "XEM TẤT CẢ CÁC TIỆN ÍCH BỔ SUNG",
        "renewValidity": "Gia hạn hiệu lực",
        "buyNow": "Mua ngay",
        "upgradeMembershipPlan": "Nâng cấp gói thành viên",
        "chooseYourMembershipPlan": "Gói thành viên bạn đã chọn",
        "chooseOptionalAddOns": "Bạn có thể chọn Tiện ích bổ sung tùy chọn",
        "yourSelectedAddons": "Tiện ích bổ sung đã chọn của bạn",
        "addAnotherAddOn": "Thêm tiện ích bổ sung khác",
        "paymentMethod": "Phương thức thanh toán",
        "addingAPaymentMethod": "Thêm phương thức thanh toán",
        "paymentSuccessful": "Thanh toán của bạn đã thành công!",
        "weHaveEmailed": "Chúng tôi đã gửi bản sao biên nhận của bạn qua email tới example@email.com",
        "paymentAuthorizedSuccessfully": "Thanh toán được ủy quyền thành công.",
        "paymentSuccessfulPrompt": "Thanh toán thành công. Kế hoạch được nâng cấp.",
        "paymentCancelled": "Thanh toán bị hủy. Vui lòng thử lại."
    },
    "registerFarm": "Đăng ký trang trại",
    "requestDeforestationReport": "Yêu cầu báo cáo nạn phá rừng",
    "paymentMenu": "Sự chi trả",
    "complianceCertificate": "Giấy chứng nhận tuân thủ",
    "helpDisk": "Đĩa trợ giúp",
    "faqs": "Câu hỏi thường gặp",
    "enquiries": "Thắc mắc",
    "contactUs": "Liên hệ chúng tôi",
    "payment": {
        "basicPlan": "Gói cơ bản",
        "advancePlan": "Kế hoạch trước",
        "usdPerMonthPlus": "USD mỗi tháng cộng thêm",
        "perReport": "mỗi báo cáo",
        "deforestationAnalyticsCertificateDownload": "Tải xuống chứng chỉ phân tích nạn phá rừng"
    },
    "farm": {
        "farmOwnershipType": "Loại quyền sở hữu trang trại",
        "licenceNum": "Số giấy phép",
        "viewFarm": "Xem trang trại",
        "stateProvince": "Tỉnh/Tiểu bang",
        "postalNumberShouldSimilarToFarm": "Số bưu điện của trang trại tương tự như số Nhà.",
        "videoTutorial": "Video hướng dẫn",
        "clickOnMapMSG": "Nhấp vào bản đồ để bắt đầu định vị địa lý",
        "prev": "Trước đó",
        "next": "Kế tiếp",
        "dragVertexMsg": "Bạn cũng có thể kéo đỉnh hoặc xóa chúng bằng nút xóa ở bên phải. Geofence cũng có thể được xóa bằng nút xóa",
        "farmAddedSuccessfully": "Trang trại được thêm thành công",
        "perimeter": "Chu vi",
        "area": "Khu vực",
        "clearGeofence": "Xóa hàng rào địa lý",
        "deleteSelectedVertex": "Xóa đỉnh đã chọn",
        "pleaseStartDrawing": "Hãy bắt đầu vẽ geofence trên bản đồ.",
        "chooseTheDate": "Chọn ngày",
        "updateGeofenceForThisFarm": "CẬP NHẬT GEOFENCE cho trang trại này",
        "farmUpdateSuccessfully": "Trang trại được cập nhật thành công",
        "farmZone": "Khu trang trại",
        "addNewZones": "Thêm vùng mới",
        "zoneName": "Tên khu vực",
        "addZoneToCreate": "Hãy nhấn vào Add Zone để tạo Zone cho trang trại này.",
        "noZoneCreated": "Chưa có Vùng nào được tạo.",
        "searchAndAddPin": "Tìm kiếm và thêm ghim",
        "zoneNameWillBeHere": "Tên khu vực sẽ ở đây",
        "editZone": "Chỉnh sửa vùng",
        "nameOfTheField": "Tên của lĩnh vực",
        "zoneDetails": "Chi tiết vùng",
        "addZone": "Thêm vùng",
        "nameOfTheZone": "Tên của khu vực",
        "geofenceIsRequiredToAdd": "Geofence là cần thiết để thêm vùng. Nhấp vào `Chỉnh sửa trang trại` để thêm chi tiết Hàng rào địa lý cho trang trại của bạn.",
        "thisFieldApplyHelpText": "Trường này chỉ áp dụng cho bạn nếu bạn thuộc bất kỳ hợp tác xã nào (Hợp tác xã là một hiệp hội tự trị của những người tự nguyện liên kết với nhau để đáp ứng các nhu cầu và nguyện vọng chung về kinh tế, xã hội và văn hóa của họ thông qua một doanh nghiệp cùng sở hữu và kiểm soát dân chủ). NẾU bạn thuộc về một hợp tác xã, vui lòng cho biết số nhận dạng duy nhất của hợp tác xã đó, đó có thể là số đăng ký hoặc số giấy phép xác định duy nhất hợp tác xã mà bạn liên kết.",
        "farmRegistrationID": "ID đăng ký trang trại",
        "farmerName": "Tên nông dân",
        "farmerRegistrationID": "ID đăng ký nông dân",
        "dateOfRequest": "Ngày yêu cầu",
        "status": "Trạng thái",
        "address": "Địa chỉ",
        "save": "Cứu",
        "farmAddress": "Địa chỉ trang trại",
        "corporateName": "Tên công ty",
        "corporateMailingAddress": "Địa chỉ gửi thư của công ty",
        "farmID": "ID trang trại",
        "onTheFarm": "Ở nông trại",
        "userRoles": "Vai trò người dùng",
        "adduser": "Thêm người dùng",
        "addAuser": "Thêm người dùng",
        "uploadUsers": "Tải người dùng lên",
        "addNewUser": "Thêm người dùng mới",
        "selectDept": "Chọn khoa",
        "selectRole": "Chọn vai trò",
        "editUser": "Người dùng biên tập",
        "totalFarms": "Tổng số trang trại",
        "NoAnimalsRegisteredForthisFarm": "Không có động vật nào được đăng ký cho trang trại này",
        "farmsPerPage": "Trang trại trên mỗi trang",
        "regularFarms": "Trang trại thông thường",
        "farmRegisteredProducts": "Sản phẩm đã đăng ký của trang trại",
        "searchByFarmNameAndId": "Tìm kiếm theo tên trang trại và Id",
        "loadingProductsPleaseWait": "Đang tải sản phẩm... Vui lòng chờ",
        "farmName": "Tên trang trại",
        "farmLocation": "Vị trí trang trại",
        "productName": "tên sản phẩm",
        "stockStatus": "Tình trạng tồn kho",
        "inStock": "Trong kho",
        "searchByProductName": "Tìm kiếm theo tên sản phẩm",
        "productCategory": "danh mục sản phẩm",
        "products": "Các sản phẩm",
        "yourLocationIsDisabled": "Vị trí của bạn bị vô hiệu hóa. Vui lòng tìm kiếm vị trí của bạn từ menu bên trái.",
        "close": "Đóng",
        "farms": "trang trại",
        "zones": "Khu vực",
        "registerAfarm": "Đăng ký một trang trại",
        "govtRegistry": "Chính phủ Đăng ký",
        "cooperativeID": "ID hợp tác xã/công đoàn",
        "cooperativeName": "Tên Hợp tác xã/Liên minh",
        "farmType": "Loại trang trại",
        "contractMating": "Giao phối hợp đồng",
        "customization": "Tùy chỉnh",
        "recordsPerpage": "Tài liệu từng trang",
        "restoreDefault": "Khôi phục lại mặc định",
        "apply": "Áp dụng",
        "CommunityName": "Tên cộng đồng",
        "searchState": "Tìm kiếm theo ID trang trại, Cơ quan đăng ký chính phủ, ID hợp tác xã, Loại trang trại, Giao phối hợp đồng",
        "farmOwner": "chủ trang trại",
        "govRegistrationNo": "Số đăng ký chính phủ",
        "farmInformation": "Thông tin trang trại",
        "ownershipType": "Loại quyền sở hữu",
        "farmLicenseInformation": "Thông tin giấy phép trang trại",
        "licenseNumber": "Số giấy phép",
        "licenseExpiryDate": "Ngày hết hạn giấy phép",
        "regulatorName": "Tên bộ điều chỉnh",
        "regulatorRepresentativeName": "Tên đại diện cơ quan quản lý",
        "farmLocationSize": "Vị trí và quy mô trang trại",
        "productionSystem": "Hệ thống canh tác",
        "country": "Quốc gia",
        "state": "Tình trạng",
        "city": "Làng/Thị trấn/Thành phố",
        "farmNumber": "Số trang trại",
        "postal": "Mã bưu điện/Zip",
        "houseNumber": "Số nhà",
        "farmRegistration": "Đăng ký trang trại",
        "cancel": "Hủy bỏ",
        "register": "Đăng ký",
        "ok": "Được rồi",
        "totalFarmSize": "Tổng quy mô trang trại",
        "geographicLocation": "Vị trí địa lý",
        "farmGeographicLocation": "Vị trí địa lý trang trại",
        "perimeterPointLongitude": "Kinh độ điểm chu vi",
        "perimeterPointLatitude": "Vĩ độ điểm chu vi",
        "perimeterPointLabel": "Nhãn điểm chu vi",
        "perimeterLength": "Chiều dài chu vi",
        "farmLatitude": "Vĩ độ trang trại",
        "farmLongitude": "Kinh độ trang trại",
        "latitude": "Vĩ độ",
        "longitude": "Kinh độ",
        "areaUnit": "Đơn vị diện tích",
        "walkAndMeasure": "ĐI VÀ ĐO",
        "useGeofenceTool": "SỬ DỤNG CÔNG CỤ GEOFENCE",
        "editFarm": "Chỉnh sửa trang trại",
        "update": "Cập nhật",
        "editAfarm": "Chỉnh sửa trang trại",
        "nextFarm": "Trang trại tiếp theo",
        "nameoftheFarm": "Tên trang trại",
        "registerAProduct": " Đăng ký một sản phẩm",
        "farmProducts": "nông sản",
        "calf": "Bắp chân",
        "steer": "Chỉ đạo",
        "heifer": "bò cái tơ",
        "sire": "thưa ngài",
        "dam": "Đập",
        "registerAnAnimal": "Đăng ký một con vật",
        "farmAnimals": "Động vật trong nông trại",
        "farm_type": "Kiểu trang trại",
        "farm_Owner": "chủ trang trại",
        "dateOfRegistration": "Ngày đăng ký",
        "dataIsNotAvailableForThisFarm": "Dữ liệu không có sẵn cho trang trại này",
        "registerNewProduct": "Đăng ký một sản phẩm mới",
        "information": "Thông tin",
        "licenseInfo": "Thông tin giấy phép",
        "locationInfo": "Thông tin vị trí",
        "geoLocation": "Vị trí địa lý",
        "perimeterLengthState": "Chiều dài chu vi trang trại (chiều dài hàng rào)",
        "totalFarmSizeState": "Kích thước của một trang trại",
        "productionSystemState": "Hệ thống sản xuất được sử dụng trong trang trại",
        "contractMatingState": "Quy tắc của Chương trình Giao phối Hợp đồng mà Trang trại tham gia.",
        "ownershipTypeState": "Loại quyền sở hữu",
        "regulatorRepresentativeNameState": "Tên người đại diện cơ quan quản lý cấp giấy phép",
        "regulatorNameState": "Tên cơ quan quản lý đã cấp giấy phép",
        "licenseExpiryDateState": "Ngày Giấy phép hiện tại hết hạn",
        "licenseNumberState": "Số giấy phép do Cơ quan quản lý cấp",
        "plotNumberState": "Số nhà của trang trại.",
        "plotNumber": "Số trang trại",
        "streetStatement": "Tên đường của trang trại.",
        "cityStatement": "Thành phố nơi trang trại tọa lạc.",
        "stateStatement": "Vùng của quốc gia nơi trang trại tọa lạc.",
        "countryState": "Quốc gia nơi trang trại tọa lạc.",
        "farmStateInfo": "Địa chỉ trang trại",
        "perimeterPointLongitudeState": "Kinh độ của một điểm trên trang trại.",
        "perimeterPointLatitudeState": "Vĩ độ của một điểm trên trang trại.",
        "perimeterPointLabelState": "Nhãn điểm.",
        "farmLongitudeState": "Kinh độ của trang trại.",
        "farmLatitudeState": "Vĩ độ của trang trại.",
        "deleteFarm": "Xóa trang trại",
        "corporateRegistrationNum": "Số đăng ký doanh nghiệp",
        "farmLocationIsRequired": "Vị trí trang trại là bắt buộc."
    },
    "deforestation": {
        "addZoneToThisFarm": "Thêm vùng vào trang trại này",
        "eudrForestAssessment": "Đánh giá rừng của EUDR",
        "requestEudrForestAssessment": "YÊU CẦU ĐÁNH GIÁ RỪNG EUDR",
        "pleaseChooseOption": "Vui lòng chọn tùy chọn",
        "requestForestReport": "Yêu cầu báo cáo rừng",
        "noDeforestationReportMsg": "Không có báo cáo nạn phá rừng nào được yêu cầu. Vui lòng yêu cầu một số báo cáo về nạn phá rừng để chúng được liệt kê ở đây.",
        "allCountries": "Tất cả các nước",
        "allRegions": "Tất cả các vùng",
        "allFarms": "Tất cả trang trại",
        "allStatus": "Tất cả các trạng thái",
        "viewCertificate": "Xem chứng chỉ",
        "requestComplianceCertificate": "YÊU CẦU GIẤY CHỨNG NHẬN TUÂN THỦ",
        "assessmentNo": "Đánh giá số",
        "blockchainCertificationInfo": "Hash xác thực chứng chỉ chuỗi khối sẽ có sẵn sau khi chấp nhận chứng chỉ",
        "blockchainCertificationValidation": "Xác thực chứng chỉ Blockchain",
        "openBlockchainPage": "Mở trang Blockchain",
        "clickOnAboveLink": "Nhấp vào liên kết ở trên để xác thực chứng chỉ trên blockchain",
        "shareCertificate": "Chia sẻ chứng chỉ",
        "high": "Cao",
        "low": "Thấp",
        "zeroOrNegigible": "Bằng không hoặc có thể bỏ qua",
        "deforestationProbability": "Xác suất phá rừng",
        "colorCode": "Mã màu",
        "geofenceAarea": "Khu vực hàng rào địa chất",
        "percentageOfGeofenceArea": "Tỷ lệ diện tích hàng rào địa chất",
        "overallDeforestationProbability": "Xác suất phá rừng tổng thể",
        "deforestationComplianceReport": "Báo cáo tuân thủ nạn phá rừng",
        "noDeforestationComplianceReport": "Không tìm thấy báo cáo điện tử tuân thủ nạn phá rừng",
        "loadingDeforestationComplianceReport": "Đang tải Báo cáo điện tử tuân thủ về phá rừng",
        "farmRegistrationId": "ID đăng ký trang trại",
        "farmerName": "Tên nông dân",
        "farmerRegistrationId": "ID đăng ký nông dân",
        "uniqueFarmerId": "ID nông dân duy nhất",
        "uniqueFarmId": "ID trang trại duy nhất",
        "farmLocation": "Vị trí trang trại",
        "area": "Khu vực",
        "farmAddress": "Địa chỉ trang trại",
        "dateOfRequest": "Ngày yêu cầu",
        "status": "Trạng thái",
        "settings": "Cài đặt",
        "assignmentIssued": "Bài tập đã được ban hành",
        "certificateIssued": "Giấy chứng nhận ban hành",
        "complianceCertification": "Chứng nhận tuân thủ",
        "noComplianceCertification": "Không tìm thấy chứng nhận tuân thủ",
        "loadingComplianceCertification": "Đang tải chứng nhận tuân thủ",
        "assessmentReport": "Báo cáo đánh giá",
        "downloadPDF": "tải PDF",
        "print": "In",
        "back": "Mặt sau",
        "farmDetails": "Chi tiết trang trại",
        "dimitraFarmId": "Mã trang trại Dimitra",
        "dimitraFermerId": "Id nông dân Dimitra",
        "totalGeofenceAreaHA": "Tổng diện tích hàng rào địa lý (HA)",
        "forestLossHA": "Mất rừng (HA)",
        "forestGainHA": "Tăng trưởng rừng (HA)",
        "forestUnchangedHA": "Rừng không thay đổi (HA)",
        "forestUnchanged": "Rừng không thay đổi",
        "forestLoss": "Mất rừng",
        "forestGain": "Tăng rừng",
        "totalGeofenceArea": "Tổng diện tích hàng rào địa lý",
        "forestAssessmentHelp": "Nếu bạn có thắc mắc về báo cáo này hoặc cần trợ giúp để hiểu báo cáo, hãy liên hệ với chúng tôi qua Bộ phận trợ giúp.",
        "allReport": "Tất cả báo cáo",
        "deforestationRepot": "Báo cáo nạn phá rừng",
        "requestDeforestationReportNow": "YÊU CẦU BÁO CÁO KHAI THÁC NGAY BÂY GIỜ",
        "noRecordFound": "Không tìm thấy bản ghi nào",
        "noDeforestationReportRequested": "Không có báo cáo nạn phá rừng nào được yêu cầu. Vui lòng yêu cầu một số báo cáo về nạn phá rừng để chúng được liệt kê ở đây.",
        "deforestationImage": "Hình ảnh nạn phá rừng",
        "reqDeforestationReport": "Yêu cầu báo cáo nạn phá rừng",
        "confirm": "Xác nhận",
        "newForestArea": "Diện tích rừng mới",
        "deforestedArea": "Khu vực bị phá rừng",
        "existingForestArea": "Diện tích rừng hiện có",
        "deforestation": "Phá rừng",
        "farmName": "Tên trang trại",
        "location": "Vị trí",
        "dateOfInterest": "Ngày quan tâm",
        "geofenceArea": "Khu vực hàng rào địa chất (HA)",
        "deforestationArea": "Khu vực phá rừng (HA)",
        "treeGainArea": "Diện tích tăng cây (HA)",
        "currentForestArea": "Diện tích rừng hiện tại (HA)",
        "view": "Xem",
        "locationInfoRequired": "Thông tin vị trí là bắt buộc",
        "geofenceNameRequired": "Tên địa chất là bắt buộc",
        "futureDateSelected": "Đã chọn ngày trong tương lai",
        "reportGeneratedSuccessfully": "Báo cáo được tạo thành công",
        "reportCannotAdded": "Không thể thêm báo cáo.",
        "primaryFarmNotFound": "Trang trại chính không được tìm thấy.",
        "pleaseRegisterFarmFirst": "Vui lòng đăng ký trang trại trước"
    },
    "certificate": {
        "allCertificate": "Tất cả các chứng chỉ",
        "certificate": "Giấy chứng nhận"
    }
}